module.exports = __webpack_public_path__ + "static/media/christmas-carol-2025.0c212457.png";